import React, { Fragment } from "react"
import { Tooltip } from "react-tooltip"

const CustomToolTip = ({ index, content, wrapperClass, position, isInputBox = false }) => { 
    return (
        <Fragment>
            { !isInputBox && 
                <span data-tooltip-id={ `tooltip-${index}` } data-tooltip-content={ content?.description }>
                    { content?.error }            
                </span>
            }
            {  <Tooltip 
                id={ `tooltip-${index}` } 
                place={ position } 
                effect="solid" 
                className={ wrapperClass ? wrapperClass : "" } /> }
        </Fragment>
    )

}
export default CustomToolTip
